import { render } from "./SimpleNoteCreateConceptModal.vue?vue&type=template&id=227e5ec7"
import script from "./SimpleNoteCreateConceptModal.vue?vue&type=script&lang=js"
export * from "./SimpleNoteCreateConceptModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__